import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    LoginDetails: {},
}

const userDetailSlice = createSlice({
    name: "userDetailSlice",
    initialState,

    reducers: {
        userDetailsData(state, action) {
            return {
                ...state,
                LoginDetails: {
                    ...state.LoginDetails,
                    ...action.payload.LoginDetails,
                }
            };
        }
    }
})
export const { userDetailsData } = userDetailSlice.actions;
export default userDetailSlice.reducer;